import React from "react";

import SocialIcons from "../components/social-icons";

export default function Home() {
  return (
    <div id="main">
      <div id="left">
        <img
          src="assets/rohan.jpg"
          alt="Rohan"
          className="noselect"
          draggable="false"
        />
      </div>

      <div className="divider"></div>

      <div id="right">
        <h1 className="noselect">Rohan Tinna</h1>
        <a id="mail" href="mailto:rohan@omg.lol" className="noselect">
          <div>
            <i className="fas fa-envelope"></i>
            <span>rohan@omg.lol</span>
          </div>
        </a>

        <p>
          Hey there 👋🏼 I am Rohan—a Web Developer and a{" "}
          <a href="https://twitter.com/hashtag/fintech">#Fintech</a> enthusiast!
          I am currently pursuing my undergraduate studies at the University of
          Toronto. You can reach out to me via Instagram or email. Once in a
          while, I post productive stuff on my{" "}
          <a href="https://medium.com/@rohantinna" className="link">
            blog
          </a>
          .
        </p>

        <SocialIcons />

        {/* 
        
        // Resume Button

        <div id="resume-btn">
          <a href="/" className="button noselect">
            <div>
              <i className="fas fa-file"></i>
              <span>Download Resumé</span>
            </div>
          </a>
        </div>
        
        */}
      </div>
    </div>
  );
}
